import OnlyofficeEditor from './onlyoffice-editor.vue'

export default OnlyofficeEditor
